import { Navigate, createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { AtlasPageView } from '@/components/Atlas/AtlasPageView';
import { RequireFeatureFlag } from '@/components/Auth/RequireFeatureFlag';
import { DocumentSetSkeletonLoader } from '@/components/CodebaseView/DocumentSet/DocumentSetSkeletonLoader';
import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { TocProvider } from '@/contexts/TocContext';
import { useCodebaseRoute } from '@/hooks/useCodebaseRoute';
import { searchParam } from '@/utils/router';

const atlasSearchSchema = z.object({
  branchId: searchParam().optional(),
  versionId: searchParam().optional(),
});

export const Route = createFileRoute('/$organizationName/cb/$codebaseId/atlas/')({
  component: GatedAtlasIndexPage,
  validateSearch: zodValidator(atlasSearchSchema),
});

// Gate the atlas index behind the SERVE_ATLAS flag. When the flag is loaded-and-off,
// redirect to this codebase's overview; while loading, show the same skeleton AtlasPageView
// shows for a pending page (avoids flashing a redirect before /me resolves). See RequireFeatureFlag.
function GatedAtlasIndexPage() {
  const { codebaseId, organizationName } = useCodebaseRoute();
  return (
    <RequireFeatureFlag
      flag={FEATURE_FLAGS.SERVE_ATLAS}
      loading={<DocumentSetSkeletonLoader />}
      redirect={
        <Navigate to="/$organizationName/cb/$codebaseId/overview/$" replace params={{ organizationName, codebaseId }} />
      }
    >
      <AtlasIndexPage />
    </RequireFeatureFlag>
  );
}

function AtlasIndexPage() {
  return (
    <TocProvider>
      <div className="mx-auto flex w-full flex-col gap-y-6 pt-4 pb-4">
        <AtlasPageView />
      </div>
    </TocProvider>
  );
}
